module.exports = __webpack_public_path__ + "media/images/landing/home/categories/events-f82c43dac57bd797a038250f0b36d8f4.png";